import React from 'react';

const LoadingSpinner = () => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh', // Take full viewport height
    textAlign: 'center',
    padding: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: slight overlay
  };

  const spinnerStyle = {
    border: '4px solid rgba(0, 0, 0, 0.1)',
    width: '48px', // Slightly larger for better visibility
    height: '48px',
    borderRadius: '50%',
    borderLeftColor: '#db3434', // Primary app color
    animation: 'spin 1s ease infinite',
    margin: '0 auto 20px auto', // Centered with margin bottom
  };

  const keyframes = `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;

  return (
    <div style={containerStyle}>
      <style>{keyframes}</style>
      <div style={spinnerStyle}></div>
      <p style={{ fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif', fontSize: '1.2rem', color: '#34495e' }}>Loading...</p>
    </div>
  );
};

export default LoadingSpinner;